<template>
  <div>
    <div class="slots-bg com-news">
      <div class="txtMarquee-left">
        <div class="block">
          <div class="iconfont icon-tongzhi2"></div>
          <p>{{$t('index.announcement')}}</p>
          <div id="memberLatestAnnouncement" @click="$parent.goNav('/message?type=1')">
            <marquee scrollamount="8" scrolldelay="100" direction="left" onclick="hotNewsHistory()" onmouseover="this.stop();" onmouseout="this.start();"
              >{{$t('index.official')}}
            </marquee>
          </div>
        </div>
      </div>
    </div>
    <div id="slots-content">
      <div class="pavilion-container">
        <div class="layer-title"></div>
        <div class="pavilion-inner">
          <ul class="tabsqh overflow-hide">
            <li :class="gamecode == null ? ' qhoff on' : 'qhoff '" @click="changgamecode(null)"><span class="hot-icon on"></span><span>{{$t('index.allgames')}}</span></li>
            <li :class="gamecode == 'obgdy' ? ' qhoff on' : 'qhoff '" @click="changgamecode('obgdy')"><span class="hot-icon on"></span><span>{{$t('index.obz')}}</span></li>
            <li :class="gamecode == 'fgdz' ? ' qhoff on' : 'qhoff '" @click="changgamecode('fgdz')"><span class="hot-icon on"></span><span>{{$t('index.fgz')}}</span></li>
            <li :class="gamecode == 'pp' ? ' qhoff on' : 'qhoff '" @click="changgamecode('pp')"><span class="hot-icon on"></span><span>{{$t('index.ppz')}}</span></li>
            <li :class="gamecode == 'ae' ? ' qhoff on' : 'qhoff '" @click="changgamecode('ae')"><span class="hot-icon on"></span><span>{{$t('index.aez')}}</span></li>
            <li :class="gamecode == 'pg' ? ' qhoff on' : 'qhoff '" @click="changgamecode('pg')"><span class="hot-icon on"></span><span>{{$t('index.pgz')}}</span></li>
            <li :class="gamecode == 'fgfish' ? ' qhoff on' : 'qhoff '" @click="changgamecode('fgfish')"><span class="hot-icon on"></span><span>{{$t('index.fgfish')}}</span></li>
          </ul>

          <div class="tab-content-wrap">
            <div :class="gamecode == null ? ' tab-content overflow-hide show' : 'tab-content overflow-hide '">
              <section id="lobby" class="ng-scope">
                <div class="elec-container" id="elec-container_">
                  <div class="elec-game-container" id="elec-game-container_">
                    <div class="elec-game-list" id="elec-game-list_">
                      <dl id="elec-game-list-box_">
                        <dd v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1 && item.platform_name != 'pg'">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="`/static/image/concise/${item.platform_name}.png`" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.name }}</h3>
                            </div>
                            <a href="javascript:;" v-if="item.platform_name == 'obgdy' || item.platform_name == 'fgdz' || item.platform_name == 'pp' || item.platform_name == 'ae'" @click="changgamecode(item.platform_name)" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                            <a href="javascript:;" v-else @click="$parent.openGamePage(item.platform_name, item.game_code, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div :class="gamecode != null ? ' tab-content overflow-hide show' : 'tab-content overflow-hide '">
              <section id="lobby" class="ng-scope">
                <div class="elec-container" id="elec-container_">
                  <div class="elec-game-container" id="elec-game-container_">
                    <div class="elec-game-list" id="elec-game-list_">
                      <dl id="elec-game-list-box_" v-if="gamecode == 'obgdy'">
                        <dd v-for="(item, index) in obgdyList" :key="index">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="item.gamepic" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.gamename }}</h3>
                            </div>
                            <a href="javascript:;" @click="$parent.openGamePage(item.catecode, item.gamecode, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                      <dl id="elec-game-list-box_" v-if="gamecode == 'fgdz'">
                        <dd v-for="(item, index) in fgdzList" :key="index">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="item.gamepic" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.gamename }}</h3>
                            </div>
                            <a href="javascript:;" @click="$parent.openGamePage(item.catecode, item.gamecode, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                      <dl id="elec-game-list-box_" v-if="gamecode == 'pp'">
                        <dd v-for="(item, index) in ppList" :key="index">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="item.gamepic" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.gamename }}</h3>
                            </div>
                            <a href="javascript:;" @click="$parent.openGamePage(item.catecode, item.gamecode, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                      <dl id="elec-game-list-box_" v-if="gamecode == 'ae'">
                        <dd v-for="(item, index) in aeList" :key="index">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="item.gamepic" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.gamename }}</h3>
                            </div>
                            <a href="javascript:;" @click="$parent.openGamePage(item.catecode, item.gamecode, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                                      <dl id="elec-game-list-box_" v-if="gamecode == 'pg'">
                        <dd v-for="(item, index) in pgList" :key="index">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="item.gamepic" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.gamename }}</h3>
                            </div>
                            <a href="javascript:;" @click="$parent.openGamePage(item.catecode, item.gamecode, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                                      <dl id="elec-game-list-box_" v-if="gamecode == 'fgfish'">
                        <dd v-for="(item, index) in fgfishList" :key="index">
                          <div class="elec-game-box">
                            <div class="elec-game-subscript"></div>
                            <div class="elec-game-img-box">
                              <img :src="item.gamepic" alt="" class="elec-game-img" />
                              <h3 class="platform-name">{{ item.gamename }}</h3>
                            </div>
                            <a href="javascript:;" @click="$parent.openGamePage(item.catecode, item.gamecode, '')" class="elec-game-hover"><span class="game-begin">{{$t('index.playgames')}}</span></a>
                          </div>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'concise',
  data() {
    return {
      obgdyList: [],
      fgdzList: [],
      ppList: [],
      aeList: [],
      pgList: [],
      fgfishList: [],
      gamecode: null,
      gameList: [],

      imgList: {
        ae: { img: '/static/image/eae.png', hover: '/static/image/ae-hover.png', title: '/static/image/img_ae_title.png' },
        icg: { img: '/static/image/eicg.png', hover: '/static/image/at-hover.png', title: '/static/image/img_at_title.png' },
        bbin: { img: '/static/image/bbin.png', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bbindz_title.png' },
        bg: { img: '/static/image/dzbgby.png', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bgby_title.png' },
        bng: { img: '/static/image/dzbng.png', hover: '/static/image/bg_hover.png', title: '/static/image/img_bng_title.png' },
        cg: { img: '/static/image/dzcg.png', hover: '/static/image/bng-hover.png', title: '/static/image/img_cg_title.png' },
        dt: { img: '/static/image/dzdt.png', hover: '/static/image/cg-hover.png', title: '/static/image/img_dt_title.png' },
        fgdz: { img: '/static/image/dzfg.png', hover: '/static/image/dt-hover.png', title: '/static/image/img_fg_title.png' },
        habaner: { img: '/static/image/dzhb.png', hover: '/static/image/fg-hover.png', title: '/static/image/img_hb_title.png' },
        hc: { img: '/static/image/dzhc.png', hover: '/static/image/hb-hover.png', title: '/static/image/img_hc_title.png' },
        jdb: { img: '/static/image/dzjdb.png', hover: '/static/image/hc-hover.png', title: '/static/image/img_jdb_title.png' },
        obgpy: { img: '/static/image/vendorGameLogoA1640062419.png', hover: '/static/image/jdb-hover.png', title: '/static/image/img_obby_title.png' },
        obgdy: { img: '/static/image/vendorGameLogoA1640062419.png', hover: '/static/image/ob-hover.png', title: '/static/image/img_obdz_title.png' },
        pg: { img: '/static/image/dzpg.png', hover: '/static/image/ob-hover.png', title: '/static/image/img_pg_title.png' },
        pp: { img: '/static/image/dzpp.png', hover: '/static/image/pg-hover.png', title: '/static/image/img_pp_title.png' },
        ps: { img: '/static/image/dzps.png', hover: '/static/image/pp-hover.png', title: '/static/image/img_ps_title.png' },
        sg: { img: '/static/image/dzsg.png', hover: '/static/image/sgdz-hover.png', title: '/static/image/img_sg_title.png' },
        zeus: { img: '/static/image/dzzeus.png', hover: '/static/image/zeus-hover.png', title: '/static/image/img_zeus_title.png' },
        bbdz: { img: '/static/image/bbin.png', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bbindz_title.png' },

        egame: { img: '/static/image/dzbgby.png', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bgby_title.png' },
      },
    };
  },
  created() {
    let that = this;
    if (this.$route.query) {
      that.gamecode = this.$route.query.type || that.gamecode;
    }
    console.log(that.gamecode);
    that.getGameList();

    that.gamelistBycode();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'concise' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.$parent.hideLoading();
        }
      });
    },
    changgamecode(code) {
      let that = this;
      if (code == that.gamecode) {
        return;
      }

      that.gamecode = code;

      that.gamelistBycode();
    },
    gamelistBycode() {
      let that = this;
      if (!that.gamecode) {
        return;
      }
      let name = that.gamecode + 'List';
      if (that[name].length > 0) {
        return;
      }
      that.$parent.showLoading();
      //  pp ae fg obgdy
      that.$apiFun
        .post('/api/gamelistBycode', { gamecode: that.gamecode })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that[name] = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/elec-game-com.css';
.pavilion-container .tab-content {
  position: relative;
}
.pavilion-container .pavilion-inner .tabsqh li.on {
  background: #c9a467;
  color: #1c1f36;
  width: 146px;
  text-align: center;
}

.pavilion-container .pavilion-inner .tabsqh li.qhoff {
     margin-left: 5.2667px;
    cursor: pointer;
    width: 136px;
    text-align: center;
}
.pavilion-container .pavilion-inner .tabsqh li .hot-icon{
  margin-right: 6px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/concise.vue